import { MATISSE_BLUE } from "../../../constants/colors";

const linkColor = MATISSE_BLUE;

export const fallbackValues = {
  linkColor
};
